import { RESET_REPORT_ROW_COUNT } from './actionTypes';

const resetReportRowCount = () => ({
    type: RESET_REPORT_ROW_COUNT,
});

export default resetReportRowCount;
